module.exports = __webpack_public_path__ + "img/actualCase-8.1c653077.jpg";